export default {
      id: "vagues_agenda-usage",
      viewBox: "0 0 1135 225",
      url: "../dist/images/" + "sprite.svg#vagues_agenda-usage",
      toString: function () {
        return this.url;
      }
    }